var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { animated, useSpring, useSpringRef, useTrail, useTransition, useChain, } from '@react-spring/web';
import styled from 'styled-components';
import useMeasure from 'react-use-measure';
import { color } from '../theme/color';
const StyledLights = styled.div `
  display: flex;
  align-items: center;
  & div[data-role='spin-light'] {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin-right: 4px;
  }
`;
export const Spinner = (_a) => {
    var { value = 3, color = 'white', spinning = true } = _a, props = __rest(_a, ["value", "color", "spinning"]);
    const [cnt, setCnt] = useState(0);
    const light = useTrail(value, {
        from: { opacity: 0 },
        opacity: cnt % value === 0 ? 1 : 0,
        onRest: () => {
            setCnt((prev) => {
                if (prev === value) {
                    return 0;
                }
                return prev + 1;
            });
        },
    });
    if (!spinning) {
        return null;
    }
    return (React.createElement(StyledLights, { className: "spinner-light", "data-role": "spinner-light", className: props.className }, light.map((v, index) => (React.createElement(animated.div, { "data-role": "spin-light", style: Object.assign({ backgroundColor: color, opacity: v.opacity }, props.style), key: index })))));
};
const StyledContainer = styled(animated.div) `
  position: relative;
`;
const StyledSpinner = styled(Spinner) `
  justify-content: center;
`;
export const Container = (props) => {
    const [ref, { height }] = useMeasure();
    const heightRef = useSpringRef();
    const opacityRef = useSpringRef();
    const [styles, api] = useSpring(() => ({ height, ref: heightRef }));
    useEffect(() => {
        api.start({ height });
    }, [height]);
    const transitions = useTransition(props.spinning, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        ref: opacityRef,
    });
    useChain([heightRef, opacityRef], [0, 0.5]);
    return (React.createElement(StyledContainer, { className: cx('spinner', props.className), style: styles },
        React.createElement("div", { ref: ref }, transitions((s, item) => {
            return item ? (React.createElement(animated.div, { style: s },
                React.createElement(StyledSpinner, { color: color.light.primary, spinning: props.spinning }))) : (React.createElement(animated.div, { style: s }, props.children));
        }))));
};
